import { render, staticRenderFns } from "./FieldText.highlightPresets.vue?vue&type=template&id=b88c1d90&"
import script from "./FieldText.highlightPresets.vue?vue&type=script&lang=js&"
export * from "./FieldText.highlightPresets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports